"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _sliders = require("../../styles/sliders");

var _reactSlick = _interopRequireDefault(require("react-slick"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

var _button = require("./button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _default = function _default(props) {
  var carouselRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(0),
      index = _useState[0],
      setIndex = _useState[1];

  var isInfinite = props.infinite || props.slides < props.children.length;
  var settings = {
    arrows: false,
    autoplay: false,
    slidesToShow: props.slides || 3,
    slidesToScroll: 1,
    initialSlide: props.slides ? props.slides % 1 * -1 : 0,
    infinite: isInfinite,
    adaptiveHeight: true,
    swipeToSlide: props.slides < props.children.length,
    afterChange: function afterChange(current) {
      return setIndex(current);
    }
  };

  var Carousel = /*#__PURE__*/_react["default"].createElement(_sliders.FeatureSliderContainer, {
    slides: props.slides || 3,
    items: [].concat(props.children).length,
    itemWidth: props.itemWidth
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({}, settings, {
    ref: carouselRef
  }), [].concat(props.children).map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(_sliders.SliderChild, {
      key: index
    }, child);
  })));

  return /*#__PURE__*/_react["default"].createElement("div", null, props.banner && /*#__PURE__*/_react["default"].createElement(_sliders.FeaturedBanner, {
    src: props.banner
  }), /*#__PURE__*/_react["default"].createElement(_sliders.FeatureContainer, {
    banner: props.banner,
    fullColor: props.fullColor,
    sideBanner: props.sideBanner,
    padding: props.padding,
    mobilePadding: props.mobilePadding
  }, /*#__PURE__*/_react["default"].createElement(_sliders.FeatureLabel, {
    banner: props.banner,
    fontColor: props.fontColor,
    labelPadding: props.labelPadding
  }, /*#__PURE__*/_react["default"].createElement(_sliders.FeatureBorder, {
    border: props.coloredBorder,
    hasCaption: props.caption,
    hasSeeAll: props.clickSeeAll,
    hasBanner: props.banner
  }, /*#__PURE__*/_react["default"].createElement(_sliders.FeatureTitleContainer, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_sliders.FeatureTitle, {
    hasCaption: props.caption
  }, props.title), props.caption && /*#__PURE__*/_react["default"].createElement(_sliders.Caption, {
    hasBanner: props.banner,
    hasSeeAll: props.clickSeeAll
  }, props.caption)), props.clickSeeAll && !props.banner && /*#__PURE__*/_react["default"].createElement(_sliders.SeeAll, {
    hasCaption: props.caption,
    hasBanner: props.banner,
    onClick: props.clickSeeAll
  }, "Show All")), props.clickSeeAll && props.banner && /*#__PURE__*/_react["default"].createElement(_sliders.SeeAll, {
    hasCaption: props.caption,
    hasBanner: props.banner,
    onClick: props.clickSeeAll
  }, "Show All")), /*#__PURE__*/_react["default"].createElement(_sliders.SliderActions, {
    border: props.coloredBorder,
    hasCaption: props.caption
  }, /*#__PURE__*/_react["default"].createElement(_sliders.ButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_button.CustomPrevButton, {
    disabled: isInfinite ? false : index === 0,
    onClick: function onClick() {
      return carouselRef.current.slickPrev();
    }
  })), /*#__PURE__*/_react["default"].createElement(_sliders.ButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_button.CustomNextButton, {
    disabled: isInfinite ? false : index >= props.children.length - props.slides,
    onClick: function onClick() {
      return carouselRef.current.slickNext();
    }
  })))), /*#__PURE__*/_react["default"].createElement(_sliders.CarouselContainer, {
    banner: props.banner
  }, Carousel)));
};

exports["default"] = _default;
module.exports = exports["default"];